import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVueDotJsComponent } from './simple-icons-vue-dot-js.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVueDotJsComponent ],
    exports:      [ SimpleIconsVueDotJsComponent ],
    bootstrap:    []
})
export class SimpleIconsVueDotJsModule {}
